// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600&family=Oswald:wght@400;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lora:wght@400;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Raleway:wght@400;500;600&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Didact+Gothic&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =====================================================================
   GOOGLE FONTS
   =====================================================================*/
   
   /* =====================================================================
      GLOBAL FRAME / NAVBAR
      =====================================================================*/
   body {
     font-family: 'Open Sans', sans-serif;
     background: #fff;
     color: #333;
   }
   /* push page content down so it sits under the fixed navbar */
   .page-container {
     position: relative;
     z-index: 2;
     width: 100%;
     padding-top: 100px; /* ~= navbar total height */
   }
   /* fixed department navbar at the very top */
   .horizontal-navbar {
     background: #1e3a5f;
     position: fixed;
     top: 0; left: 0; right: 0;
     z-index: 3;
     padding: 17px 0;
     display: flex;
     align-items: center;
     justify-content: center;
   }
   /* your department “logo” on the left edge */
   .horizontal-navbar::before {
     content: "Department of Computer Systems Engineering";
     position: absolute;
     left: 20px;
     font-family: 'Oswald', sans-serif;
     font-weight: 600;
     font-size: 0.9rem;
     color: #fff;
   }
   /* centered menu items */
   .horizontal-navbar ul {
     display: flex;
     justify-content: center;
     gap: 15px;
     margin: 0;
     font-size: 1.3rem;
     padding: 0;
     list-style: none;
   }
   .horizontal-navbar a {
     color: #fff;
     font-family: 'Oswald', sans-serif;
     font-weight: 500;
     text-decoration: none;
     transition: color .3s;
   }
   .horizontal-navbar a:hover {
     color: #4e73df;
   }
   /* hamburger icon (desktop hidden) */
   .horizontal-navbar .hamburger {
     display: none;
     position: absolute;
     right: 20px;
     font-size: 1.6rem;
     color: #fff;
     cursor: pointer;
     z-index: 4;
   }
   
   /* =====================================================================
      HERO (MAIN) SLIDER
      =====================================================================*/
   .carousel {
     position: relative;
     height: calc(100vh - 66px);
     width: 100%;
     overflow: hidden;
     background: #000;
   }
   .carousel .item {
     position: absolute;
     inset: 0;
     opacity: 0;
     transition: opacity .8s;
   }
   .carousel .item.active {
     opacity: 1; z-index: 1;
   }
   .carousel .item img {
     width: 100%; height: 100%; object-fit: cover;
   }
   .carousel .item::before {
     content: "";
     position: absolute; inset: 0;
     pointer-events: none;
     background: linear-gradient(24deg, hsl(240 100% 3%) 4%, rgba(0,1,16,.92) 17%, transparent 100%);
     z-index: 1;
   }
   /* fixed transform center */
   .carousel .content {
     position: absolute;
     top: 30%; left: 50%;
     transform: translate(-50%, 50px);
     width: 60%;
     color: #fff;
     opacity: 0;
     transition: opacity .8s, transform .8s;
     z-index: 2;
   }
   .carousel .item.active .content {
     opacity: 1;
     transform: translate(-50%, 0);
   }
   .carousel .content p {
     font: .95rem 'Raleway', sans-serif;
     letter-spacing: 2px;
     line-height: 1.3;
     margin: 0 0 .5rem;
   }
   .carousel .content .title {
     font: 700 3.5rem 'Didact Gothic', sans-serif;
     line-height: 1;
     margin-bottom: .5rem;
     color: #1e3a5f;
     max-width: 100%;
     word-break: break-word;
     overflow: hidden; text-overflow: ellipsis;
     display: -webkit-box;
     -webkit-box-orient: vertical;
     -webkit-line-clamp: 2;
     line-clamp: 2;

     
  
   }
   .carousel .content .description {
     font: .75rem/1.25 'Lora', serif;
     max-width: 700px;
   }
   .carousel .arrows {
     position: absolute;
     top: 50%; left: 0; width: 100%;
     display: flex; justify-content: space-between;
     padding: 0 2%;
     transform: translateY(-50%);
   }
   .carousel .arrows button {
     background: none;
     border: 0; cursor: pointer;
     color: #fff;
     font-size: 3rem;
     line-height: 1;
     transition: color .3s;
   }
   .carousel .arrows button:hover {
     color: #f1683a;
   }
   #prev::before { content: '‹'; }
   #next::before { content: '›'; }
   
   /* =====================================================================
      CONTENT SECTIONS
      =====================================================================*/
   .upload-section {
     background: #fff;
     border-radius: 0;
     padding: 20px;
     margin-bottom: 20px;
     box-shadow: 0 4px 12px rgba(0,0,0,.05);
   }
   .upload-section::after {
     content: "";
     display: block;
     clear: both;
   }
   .upload-section h3 {
     font: 1.8rem 'Oswald', sans-serif;
     color: #000;
     margin-bottom: 15px;
     border-bottom: 2px solid #bbb;
     padding-bottom: 5px;
   }
   .upload-section p {
     font-size: .8rem;
     line-height: 1.45;
     color: #000;
   }
   
   /* chairman image */
   .chairman-image {
     width: 300px; height: auto;
     object-fit: cover;
     border-radius: 0;
     float: left;
     margin: 0 15px 10px 0;
   }
   
   /* =====================================================================
      CARD COMPONENTS
      =====================================================================*/
   .common-card {
     background: #fff;
     box-shadow: 0 2px 8px rgba(0,0,0,.05);
     height: 333px;
     padding: 1px;
     display: flex;
     flex-direction: column;
     overflow: hidden;
     border-radius: 0;
   }
   .common-card-image {
     width: 100%;
     height: 260px;
     object-fit: cover;
     border-radius: 0;
   }
   .card-content {
     display: flex;
     flex-direction: column;
     flex: 1 1;
     margin-top: 5px;
   }
   .card-title {
     font: 700 1rem 'Didact Gothic', sans-serif;
     color: #1e3a5f;
     white-space: nowrap;
     overflow: hidden;
     text-overflow: ellipsis;
     display: -webkit-box;
     -webkit-line-clamp: 1;
     line-clamp: 1;
     -webkit-box-orient: vertical;
   }
   .card-description {
     font: .75rem 'Didact Gothic', sans-serif;
     color: #000;
     line-height: 1.25;
     display: -webkit-box;
     -webkit-line-clamp: 2;
     line-clamp: 2;
     -webkit-box-orient: vertical;
     overflow: hidden;
     text-overflow: ellipsis;
   }
   .two-lines {
     display: -webkit-box;
     -webkit-line-clamp: 2;
     line-clamp: 2;
     -webkit-box-orient: vertical;
     overflow: hidden;
     text-overflow: ellipsis;
   }
   
   /* =====================================================================
      IMAGE SIZING
      =====================================================================*/
   .owl-carousel img,
   .main-research img,
   .main-news img,
   .main-circulars img {
     width: 100%;
     height: 250px;
     object-fit: cover;
     border-radius: 0;
   }
   
   /* SLIDER CARD TEXT */
   .research-slider h4,
   .news-slider h4,
   .circulars-slider h4 {
     font-family: 'Oswald', sans-serif;
     color: #1e3a5f;
     margin-top: 10px;
     white-space: nowrap;
     overflow: hidden;
     text-overflow: ellipsis;
   }
   .research-slider p,
   .news-slider p,
   .circulars-slider p {
     font-size: .75rem;
     color: #000;
     line-height: 1.4;
   }
   
   /* =====================================================================
      OWL ARROWS
      =====================================================================*/
   .owl-carousel {
     position: relative;
   }
   .owl-carousel .owl-nav {
     position: static;
     margin: 8px 0 0;
     width: 100%;
     display: flex;
     justify-content: space-between;
     pointer-events: none;
   }
   .owl-carousel .owl-prev,
   .owl-carousel .owl-next {
     pointer-events: all;
     color: #007bff;
     background: transparent;
     border: 1px solid #007bff;
     border-radius: 50%;
     padding: 6px 12px;
     font-size: 1.35rem;
     line-height: 1;
     transition: background .3s, color .3s;
   }
   .owl-carousel .owl-prev:hover,
   .owl-carousel .owl-next:hover {
     background: #007bff;
     color: #fff;
   }
   .owl-carousel .owl-prev::before { content: '‹'; }
   .owl-carousel .owl-next::before { content: '›'; }
   .owl-carousel .owl-nav~.owl-nav { display: none!important; }
   
   /* =====================================================================
      RESPONSIVE
      =====================================================================*/
   @media (max-width: 768px) {
     .carousel .content {
       width: 80%;
       left: 50%;
       top: 30%;
       transform: translate(-50%, 50px);
     }
     .carousel .content .title { font-size: 2.2rem; }
     .carousel .content p { font-size: .85rem; }
     .carousel .content .description { font-size: .75rem; }
     .horizontal-navbar ul { flex-direction: column; align-items: center; }
     .carousel .arrows button { font-size: 2.2rem; }
     .upload-section { padding: 15px; }
     .chairman-image { width: 140px; margin: 0 10px 8px 0; }
   
     /* hide desktop menu, show hamburger */
     .horizontal-navbar .hamburger { display: block; }
     .horizontal-navbar .horizontal-navbar-menu {
       display: none;
       position: absolute;
       top: 100%;
       left: 0; right: 0;
       flex-direction: column;
       background: #1e3a5f;
       padding: 10px 0;
     }
     .horizontal-navbar .horizontal-navbar-menu.open {
       display: flex;
     }
     .horizontal-navbar .horizontal-navbar-menu li {
       margin: 8px 0;
       text-align: center;
     }
   }
   
   /* =====================================================================
      PEO cards container & card styles
      =====================================================================*/
   .peo-cards-container {
     display: flex;
     flex-wrap: wrap;
     gap: 15px;
     margin-top: 10px;
   }
   .peo-card {
     flex-grow: 1;
     flex-shrink: 1;
     flex-basis: calc(33.333% - 15px);
     padding: 15px;
     border-radius: 8px;
     color: #fff;
     font-family: 'Oswald', sans-serif;
     font-weight: 500;
     box-shadow: 0 2px 6px rgba(0,0,0,0.1);
   }
   @media (max-width: 768px) {
     .peo-card { flex: 1 1 100%; }
   }
   
   /* ────────────────────────────────────────────────────────────────────
      Chairman Message — enhanced styling (no italics)
   ──────────────────────────────────────────────────────────────────── */
   #chairman-message.upload-section {
     background: #eef6fb;
     border-left: 6px solid #1e3a5f;
     padding: 40px 30px;
     border-radius: 4px;
     box-shadow: 0 4px 8px rgba(0,0,0,0.05);
   }
   #chairman-message.upload-section h3 {
     font-family: 'Oswald', sans-serif;
     color: #1e3a5f;
     font-size: 2.2rem;
     text-align: center;
     text-transform: uppercase;
     margin-bottom: 15px;
     position: relative;
   }
   #chairman-message.upload-section h3::after {
     content: '';
     display: block;
     width: 60px;
     height: 4px;
     background: #f1c40f;
     margin: 8px auto 0;
   }
   #chairman-message.upload-section p {
     font-family: 'Lora', serif;
     font-size: 1.05rem;
     line-height: 1.75;
     color: #333;
     text-align: justify;
     margin-top: 20px;
   }
   #chairman-message.upload-section p::first-letter {
     float: left;
     font-size: 3rem;
     font-weight: bold;
     line-height: 1;
     margin-right: 12px;
     color: #1e3a5f;
   }
   
   /* ────────────────────────────────────────────────────────────────────
      Introduction extra‐lines cards
   ──────────────────────────────────────────────────────────────────── */
   .intro-cards-container {
     display: flex;
     flex-wrap: wrap;
     gap: 15px;
     margin-top: 10px;
   }
   .intro-card {
     flex-grow: 1;
     flex-shrink: 1;
     flex-basis: calc(25% - 15px);
     padding: 15px;
     border-radius: 8px;
     color: #fff;
     font-family: 'Oswald', sans-serif;
     font-weight: 500;
     box-shadow: 0 2px 6px rgba(0,0,0,0.1);
     text-align: center;
   }
   @media (max-width: 768px) {
     .intro-card { flex: 1 1 100%; }
   }
   `, "",{"version":3,"sources":["webpack://./src/components/Departments.css"],"names":[],"mappings":"AAAA;;yEAEyE;;GAMtE;;4EAEyE;GACzE;KACE,oCAAoC;KACpC,gBAAgB;KAChB,WAAW;GACb;GACA,6DAA6D;GAC7D;KACE,kBAAkB;KAClB,UAAU;KACV,WAAW;KACX,kBAAkB,EAAE,2BAA2B;GACjD;GACA,4CAA4C;GAC5C;KACE,mBAAmB;KACnB,eAAe;KACf,MAAM,EAAE,OAAO,EAAE,QAAQ;KACzB,UAAU;KACV,eAAe;KACf,aAAa;KACb,mBAAmB;KACnB,uBAAuB;GACzB;GACA,4CAA4C;GAC5C;KACE,qDAAqD;KACrD,kBAAkB;KAClB,UAAU;KACV,iCAAiC;KACjC,gBAAgB;KAChB,iBAAiB;KACjB,WAAW;GACb;GACA,wBAAwB;GACxB;KACE,aAAa;KACb,uBAAuB;KACvB,SAAS;KACT,SAAS;KACT,iBAAiB;KACjB,UAAU;KACV,gBAAgB;GAClB;GACA;KACE,WAAW;KACX,iCAAiC;KACjC,gBAAgB;KAChB,qBAAqB;KACrB,qBAAqB;GACvB;GACA;KACE,cAAc;GAChB;GACA,oCAAoC;GACpC;KACE,aAAa;KACb,kBAAkB;KAClB,WAAW;KACX,iBAAiB;KACjB,WAAW;KACX,eAAe;KACf,UAAU;GACZ;;GAEA;;4EAEyE;GACzE;KACE,kBAAkB;KAClB,0BAA0B;KAC1B,WAAW;KACX,gBAAgB;KAChB,gBAAgB;GAClB;GACA;KACE,kBAAkB;KAClB,QAAQ;KACR,UAAU;KACV,uBAAuB;GACzB;GACA;KACE,UAAU,EAAE,UAAU;GACxB;GACA;KACE,WAAW,EAAE,YAAY,EAAE,iBAAiB;GAC9C;GACA;KACE,WAAW;KACX,kBAAkB,EAAE,QAAQ;KAC5B,oBAAoB;KACpB,+FAA+F;KAC/F,UAAU;GACZ;GACA,2BAA2B;GAC3B;KACE,kBAAkB;KAClB,QAAQ,EAAE,SAAS;KACnB,gCAAgC;KAChC,UAAU;KACV,WAAW;KACX,UAAU;KACV,sCAAsC;KACtC,UAAU;GACZ;GACA;KACE,UAAU;KACV,6BAA6B;GAC/B;GACA;KACE,kCAAkC;KAClC,mBAAmB;KACnB,gBAAgB;KAChB,iBAAiB;GACnB;GACA;KACE,4CAA4C;KAC5C,cAAc;KACd,oBAAoB;KACpB,cAAc;KACd,eAAe;KACf,sBAAsB;KACtB,gBAAgB,EAAE,uBAAuB;KACzC,oBAAoB;KACpB,4BAA4B;KAC5B,qBAAqB;KACrB,aAAa;;;;GAIf;GACA;KACE,+BAA+B;KAC/B,gBAAgB;GAClB;GACA;KACE,kBAAkB;KAClB,QAAQ,EAAE,OAAO,EAAE,WAAW;KAC9B,aAAa,EAAE,8BAA8B;KAC7C,aAAa;KACb,2BAA2B;GAC7B;GACA;KACE,gBAAgB;KAChB,SAAS,EAAE,eAAe;KAC1B,WAAW;KACX,eAAe;KACf,cAAc;KACd,qBAAqB;GACvB;GACA;KACE,cAAc;GAChB;GACA,gBAAgB,YAAY,EAAE;GAC9B,gBAAgB,YAAY,EAAE;;GAE9B;;4EAEyE;GACzE;KACE,gBAAgB;KAChB,gBAAgB;KAChB,aAAa;KACb,mBAAmB;KACnB,sCAAsC;GACxC;GACA;KACE,WAAW;KACX,cAAc;KACd,WAAW;GACb;GACA;KACE,iCAAiC;KACjC,WAAW;KACX,mBAAmB;KACnB,6BAA6B;KAC7B,mBAAmB;GACrB;GACA;KACE,gBAAgB;KAChB,iBAAiB;KACjB,WAAW;GACb;;GAEA,mBAAmB;GACnB;KACE,YAAY,EAAE,YAAY;KAC1B,iBAAiB;KACjB,gBAAgB;KAChB,WAAW;KACX,qBAAqB;GACvB;;GAEA;;4EAEyE;GACzE;KACE,gBAAgB;KAChB,qCAAqC;KACrC,aAAa;KACb,YAAY;KACZ,aAAa;KACb,sBAAsB;KACtB,gBAAgB;KAChB,gBAAgB;GAClB;GACA;KACE,WAAW;KACX,aAAa;KACb,iBAAiB;KACjB,gBAAgB;GAClB;GACA;KACE,aAAa;KACb,sBAAsB;KACtB,SAAO;KACP,eAAe;GACjB;GACA;KACE,0CAA0C;KAC1C,cAAc;KACd,mBAAmB;KACnB,gBAAgB;KAChB,uBAAuB;KACvB,oBAAoB;KACpB,qBAAqB;KACrB,aAAa;KACb,4BAA4B;GAC9B;GACA;KACE,wCAAwC;KACxC,WAAW;KACX,iBAAiB;KACjB,oBAAoB;KACpB,qBAAqB;KACrB,aAAa;KACb,4BAA4B;KAC5B,gBAAgB;KAChB,uBAAuB;GACzB;GACA;KACE,oBAAoB;KACpB,qBAAqB;KACrB,aAAa;KACb,4BAA4B;KAC5B,gBAAgB;KAChB,uBAAuB;GACzB;;GAEA;;4EAEyE;GACzE;;;;KAIE,WAAW;KACX,aAAa;KACb,iBAAiB;KACjB,gBAAgB;GAClB;;GAEA,qBAAqB;GACrB;;;KAGE,iCAAiC;KACjC,cAAc;KACd,gBAAgB;KAChB,mBAAmB;KACnB,gBAAgB;KAChB,uBAAuB;GACzB;GACA;;;KAGE,iBAAiB;KACjB,WAAW;KACX,gBAAgB;GAClB;;GAEA;;4EAEyE;GACzE;KACE,kBAAkB;GACpB;GACA;KACE,gBAAgB;KAChB,eAAe;KACf,WAAW;KACX,aAAa;KACb,8BAA8B;KAC9B,oBAAoB;GACtB;GACA;;KAEE,mBAAmB;KACnB,cAAc;KACd,uBAAuB;KACvB,yBAAyB;KACzB,kBAAkB;KAClB,iBAAiB;KACjB,kBAAkB;KAClB,cAAc;KACd,qCAAqC;GACvC;GACA;;KAEE,mBAAmB;KACnB,WAAW;GACb;GACA,kCAAkC,YAAY,EAAE;GAChD,kCAAkC,YAAY,EAAE;GAChD,kCAAkC,uBAAuB,EAAE;;GAE3D;;4EAEyE;GACzE;KACE;OACE,UAAU;OACV,SAAS;OACT,QAAQ;OACR,gCAAgC;KAClC;KACA,4BAA4B,iBAAiB,EAAE;KAC/C,uBAAuB,iBAAiB,EAAE;KAC1C,kCAAkC,iBAAiB,EAAE;KACrD,wBAAwB,sBAAsB,EAAE,mBAAmB,EAAE;KACrE,2BAA2B,iBAAiB,EAAE;KAC9C,kBAAkB,aAAa,EAAE;KACjC,kBAAkB,YAAY,EAAE,oBAAoB,EAAE;;KAEtD,sCAAsC;KACtC,gCAAgC,cAAc,EAAE;KAChD;OACE,aAAa;OACb,kBAAkB;OAClB,SAAS;OACT,OAAO,EAAE,QAAQ;OACjB,sBAAsB;OACtB,mBAAmB;OACnB,eAAe;KACjB;KACA;OACE,aAAa;KACf;KACA;OACE,aAAa;OACb,kBAAkB;KACpB;GACF;;GAEA;;4EAEyE;GACzE;KACE,aAAa;KACb,eAAe;KACf,SAAS;KACT,gBAAgB;GAClB;GACA;KACE,YAA8B;KAA9B,cAA8B;KAA9B,gCAA8B;KAC9B,aAAa;KACb,kBAAkB;KAClB,WAAW;KACX,iCAAiC;KACjC,gBAAgB;KAChB,qCAAqC;GACvC;GACA;KACE,YAAY,cAAc,EAAE;GAC9B;;GAEA;;yEAEsE;GACtE;KACE,mBAAmB;KACnB,8BAA8B;KAC9B,kBAAkB;KAClB,kBAAkB;KAClB,sCAAsC;GACxC;GACA;KACE,iCAAiC;KACjC,cAAc;KACd,iBAAiB;KACjB,kBAAkB;KAClB,yBAAyB;KACzB,mBAAmB;KACnB,kBAAkB;GACpB;GACA;KACE,WAAW;KACX,cAAc;KACd,WAAW;KACX,WAAW;KACX,mBAAmB;KACnB,kBAAkB;GACpB;GACA;KACE,0BAA0B;KAC1B,kBAAkB;KAClB,iBAAiB;KACjB,WAAW;KACX,mBAAmB;KACnB,gBAAgB;GAClB;GACA;KACE,WAAW;KACX,eAAe;KACf,iBAAiB;KACjB,cAAc;KACd,kBAAkB;KAClB,cAAc;GAChB;;GAEA;;yEAEsE;GACtE;KACE,aAAa;KACb,eAAe;KACf,SAAS;KACT,gBAAgB;GAClB;GACA;KACE,YAA0B;KAA1B,cAA0B;KAA1B,4BAA0B;KAC1B,aAAa;KACb,kBAAkB;KAClB,WAAW;KACX,iCAAiC;KACjC,gBAAgB;KAChB,qCAAqC;KACrC,kBAAkB;GACpB;GACA;KACE,cAAc,cAAc,EAAE;GAChC","sourcesContent":["/* =====================================================================\r\n   GOOGLE FONTS\r\n   =====================================================================*/\r\n   @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600&family=Oswald:wght@400;700&display=swap');\r\n   @import url('https://fonts.googleapis.com/css2?family=Lora:wght@400;700&display=swap');\r\n   @import url('https://fonts.googleapis.com/css2?family=Raleway:wght@400;500;600&display=swap');\r\n   @import url('https://fonts.googleapis.com/css2?family=Didact+Gothic&display=swap');\r\n   \r\n   /* =====================================================================\r\n      GLOBAL FRAME / NAVBAR\r\n      =====================================================================*/\r\n   body {\r\n     font-family: 'Open Sans', sans-serif;\r\n     background: #fff;\r\n     color: #333;\r\n   }\r\n   /* push page content down so it sits under the fixed navbar */\r\n   .page-container {\r\n     position: relative;\r\n     z-index: 2;\r\n     width: 100%;\r\n     padding-top: 100px; /* ~= navbar total height */\r\n   }\r\n   /* fixed department navbar at the very top */\r\n   .horizontal-navbar {\r\n     background: #1e3a5f;\r\n     position: fixed;\r\n     top: 0; left: 0; right: 0;\r\n     z-index: 3;\r\n     padding: 17px 0;\r\n     display: flex;\r\n     align-items: center;\r\n     justify-content: center;\r\n   }\r\n   /* your department “logo” on the left edge */\r\n   .horizontal-navbar::before {\r\n     content: \"Department of Computer Systems Engineering\";\r\n     position: absolute;\r\n     left: 20px;\r\n     font-family: 'Oswald', sans-serif;\r\n     font-weight: 600;\r\n     font-size: 0.9rem;\r\n     color: #fff;\r\n   }\r\n   /* centered menu items */\r\n   .horizontal-navbar ul {\r\n     display: flex;\r\n     justify-content: center;\r\n     gap: 15px;\r\n     margin: 0;\r\n     font-size: 1.3rem;\r\n     padding: 0;\r\n     list-style: none;\r\n   }\r\n   .horizontal-navbar a {\r\n     color: #fff;\r\n     font-family: 'Oswald', sans-serif;\r\n     font-weight: 500;\r\n     text-decoration: none;\r\n     transition: color .3s;\r\n   }\r\n   .horizontal-navbar a:hover {\r\n     color: #4e73df;\r\n   }\r\n   /* hamburger icon (desktop hidden) */\r\n   .horizontal-navbar .hamburger {\r\n     display: none;\r\n     position: absolute;\r\n     right: 20px;\r\n     font-size: 1.6rem;\r\n     color: #fff;\r\n     cursor: pointer;\r\n     z-index: 4;\r\n   }\r\n   \r\n   /* =====================================================================\r\n      HERO (MAIN) SLIDER\r\n      =====================================================================*/\r\n   .carousel {\r\n     position: relative;\r\n     height: calc(100vh - 66px);\r\n     width: 100%;\r\n     overflow: hidden;\r\n     background: #000;\r\n   }\r\n   .carousel .item {\r\n     position: absolute;\r\n     inset: 0;\r\n     opacity: 0;\r\n     transition: opacity .8s;\r\n   }\r\n   .carousel .item.active {\r\n     opacity: 1; z-index: 1;\r\n   }\r\n   .carousel .item img {\r\n     width: 100%; height: 100%; object-fit: cover;\r\n   }\r\n   .carousel .item::before {\r\n     content: \"\";\r\n     position: absolute; inset: 0;\r\n     pointer-events: none;\r\n     background: linear-gradient(24deg, hsl(240 100% 3%) 4%, rgba(0,1,16,.92) 17%, transparent 100%);\r\n     z-index: 1;\r\n   }\r\n   /* fixed transform center */\r\n   .carousel .content {\r\n     position: absolute;\r\n     top: 30%; left: 50%;\r\n     transform: translate(-50%, 50px);\r\n     width: 60%;\r\n     color: #fff;\r\n     opacity: 0;\r\n     transition: opacity .8s, transform .8s;\r\n     z-index: 2;\r\n   }\r\n   .carousel .item.active .content {\r\n     opacity: 1;\r\n     transform: translate(-50%, 0);\r\n   }\r\n   .carousel .content p {\r\n     font: .95rem 'Raleway', sans-serif;\r\n     letter-spacing: 2px;\r\n     line-height: 1.3;\r\n     margin: 0 0 .5rem;\r\n   }\r\n   .carousel .content .title {\r\n     font: 700 3.5rem 'Didact Gothic', sans-serif;\r\n     line-height: 1;\r\n     margin-bottom: .5rem;\r\n     color: #1e3a5f;\r\n     max-width: 100%;\r\n     word-break: break-word;\r\n     overflow: hidden; text-overflow: ellipsis;\r\n     display: -webkit-box;\r\n     -webkit-box-orient: vertical;\r\n     -webkit-line-clamp: 2;\r\n     line-clamp: 2;\r\n\r\n     \r\n  \r\n   }\r\n   .carousel .content .description {\r\n     font: .75rem/1.25 'Lora', serif;\r\n     max-width: 700px;\r\n   }\r\n   .carousel .arrows {\r\n     position: absolute;\r\n     top: 50%; left: 0; width: 100%;\r\n     display: flex; justify-content: space-between;\r\n     padding: 0 2%;\r\n     transform: translateY(-50%);\r\n   }\r\n   .carousel .arrows button {\r\n     background: none;\r\n     border: 0; cursor: pointer;\r\n     color: #fff;\r\n     font-size: 3rem;\r\n     line-height: 1;\r\n     transition: color .3s;\r\n   }\r\n   .carousel .arrows button:hover {\r\n     color: #f1683a;\r\n   }\r\n   #prev::before { content: '‹'; }\r\n   #next::before { content: '›'; }\r\n   \r\n   /* =====================================================================\r\n      CONTENT SECTIONS\r\n      =====================================================================*/\r\n   .upload-section {\r\n     background: #fff;\r\n     border-radius: 0;\r\n     padding: 20px;\r\n     margin-bottom: 20px;\r\n     box-shadow: 0 4px 12px rgba(0,0,0,.05);\r\n   }\r\n   .upload-section::after {\r\n     content: \"\";\r\n     display: block;\r\n     clear: both;\r\n   }\r\n   .upload-section h3 {\r\n     font: 1.8rem 'Oswald', sans-serif;\r\n     color: #000;\r\n     margin-bottom: 15px;\r\n     border-bottom: 2px solid #bbb;\r\n     padding-bottom: 5px;\r\n   }\r\n   .upload-section p {\r\n     font-size: .8rem;\r\n     line-height: 1.45;\r\n     color: #000;\r\n   }\r\n   \r\n   /* chairman image */\r\n   .chairman-image {\r\n     width: 300px; height: auto;\r\n     object-fit: cover;\r\n     border-radius: 0;\r\n     float: left;\r\n     margin: 0 15px 10px 0;\r\n   }\r\n   \r\n   /* =====================================================================\r\n      CARD COMPONENTS\r\n      =====================================================================*/\r\n   .common-card {\r\n     background: #fff;\r\n     box-shadow: 0 2px 8px rgba(0,0,0,.05);\r\n     height: 333px;\r\n     padding: 1px;\r\n     display: flex;\r\n     flex-direction: column;\r\n     overflow: hidden;\r\n     border-radius: 0;\r\n   }\r\n   .common-card-image {\r\n     width: 100%;\r\n     height: 260px;\r\n     object-fit: cover;\r\n     border-radius: 0;\r\n   }\r\n   .card-content {\r\n     display: flex;\r\n     flex-direction: column;\r\n     flex: 1;\r\n     margin-top: 5px;\r\n   }\r\n   .card-title {\r\n     font: 700 1rem 'Didact Gothic', sans-serif;\r\n     color: #1e3a5f;\r\n     white-space: nowrap;\r\n     overflow: hidden;\r\n     text-overflow: ellipsis;\r\n     display: -webkit-box;\r\n     -webkit-line-clamp: 1;\r\n     line-clamp: 1;\r\n     -webkit-box-orient: vertical;\r\n   }\r\n   .card-description {\r\n     font: .75rem 'Didact Gothic', sans-serif;\r\n     color: #000;\r\n     line-height: 1.25;\r\n     display: -webkit-box;\r\n     -webkit-line-clamp: 2;\r\n     line-clamp: 2;\r\n     -webkit-box-orient: vertical;\r\n     overflow: hidden;\r\n     text-overflow: ellipsis;\r\n   }\r\n   .two-lines {\r\n     display: -webkit-box;\r\n     -webkit-line-clamp: 2;\r\n     line-clamp: 2;\r\n     -webkit-box-orient: vertical;\r\n     overflow: hidden;\r\n     text-overflow: ellipsis;\r\n   }\r\n   \r\n   /* =====================================================================\r\n      IMAGE SIZING\r\n      =====================================================================*/\r\n   .owl-carousel img,\r\n   .main-research img,\r\n   .main-news img,\r\n   .main-circulars img {\r\n     width: 100%;\r\n     height: 250px;\r\n     object-fit: cover;\r\n     border-radius: 0;\r\n   }\r\n   \r\n   /* SLIDER CARD TEXT */\r\n   .research-slider h4,\r\n   .news-slider h4,\r\n   .circulars-slider h4 {\r\n     font-family: 'Oswald', sans-serif;\r\n     color: #1e3a5f;\r\n     margin-top: 10px;\r\n     white-space: nowrap;\r\n     overflow: hidden;\r\n     text-overflow: ellipsis;\r\n   }\r\n   .research-slider p,\r\n   .news-slider p,\r\n   .circulars-slider p {\r\n     font-size: .75rem;\r\n     color: #000;\r\n     line-height: 1.4;\r\n   }\r\n   \r\n   /* =====================================================================\r\n      OWL ARROWS\r\n      =====================================================================*/\r\n   .owl-carousel {\r\n     position: relative;\r\n   }\r\n   .owl-carousel .owl-nav {\r\n     position: static;\r\n     margin: 8px 0 0;\r\n     width: 100%;\r\n     display: flex;\r\n     justify-content: space-between;\r\n     pointer-events: none;\r\n   }\r\n   .owl-carousel .owl-prev,\r\n   .owl-carousel .owl-next {\r\n     pointer-events: all;\r\n     color: #007bff;\r\n     background: transparent;\r\n     border: 1px solid #007bff;\r\n     border-radius: 50%;\r\n     padding: 6px 12px;\r\n     font-size: 1.35rem;\r\n     line-height: 1;\r\n     transition: background .3s, color .3s;\r\n   }\r\n   .owl-carousel .owl-prev:hover,\r\n   .owl-carousel .owl-next:hover {\r\n     background: #007bff;\r\n     color: #fff;\r\n   }\r\n   .owl-carousel .owl-prev::before { content: '‹'; }\r\n   .owl-carousel .owl-next::before { content: '›'; }\r\n   .owl-carousel .owl-nav~.owl-nav { display: none!important; }\r\n   \r\n   /* =====================================================================\r\n      RESPONSIVE\r\n      =====================================================================*/\r\n   @media (max-width: 768px) {\r\n     .carousel .content {\r\n       width: 80%;\r\n       left: 50%;\r\n       top: 30%;\r\n       transform: translate(-50%, 50px);\r\n     }\r\n     .carousel .content .title { font-size: 2.2rem; }\r\n     .carousel .content p { font-size: .85rem; }\r\n     .carousel .content .description { font-size: .75rem; }\r\n     .horizontal-navbar ul { flex-direction: column; align-items: center; }\r\n     .carousel .arrows button { font-size: 2.2rem; }\r\n     .upload-section { padding: 15px; }\r\n     .chairman-image { width: 140px; margin: 0 10px 8px 0; }\r\n   \r\n     /* hide desktop menu, show hamburger */\r\n     .horizontal-navbar .hamburger { display: block; }\r\n     .horizontal-navbar .horizontal-navbar-menu {\r\n       display: none;\r\n       position: absolute;\r\n       top: 100%;\r\n       left: 0; right: 0;\r\n       flex-direction: column;\r\n       background: #1e3a5f;\r\n       padding: 10px 0;\r\n     }\r\n     .horizontal-navbar .horizontal-navbar-menu.open {\r\n       display: flex;\r\n     }\r\n     .horizontal-navbar .horizontal-navbar-menu li {\r\n       margin: 8px 0;\r\n       text-align: center;\r\n     }\r\n   }\r\n   \r\n   /* =====================================================================\r\n      PEO cards container & card styles\r\n      =====================================================================*/\r\n   .peo-cards-container {\r\n     display: flex;\r\n     flex-wrap: wrap;\r\n     gap: 15px;\r\n     margin-top: 10px;\r\n   }\r\n   .peo-card {\r\n     flex: 1 1 calc(33.333% - 15px);\r\n     padding: 15px;\r\n     border-radius: 8px;\r\n     color: #fff;\r\n     font-family: 'Oswald', sans-serif;\r\n     font-weight: 500;\r\n     box-shadow: 0 2px 6px rgba(0,0,0,0.1);\r\n   }\r\n   @media (max-width: 768px) {\r\n     .peo-card { flex: 1 1 100%; }\r\n   }\r\n   \r\n   /* ────────────────────────────────────────────────────────────────────\r\n      Chairman Message — enhanced styling (no italics)\r\n   ──────────────────────────────────────────────────────────────────── */\r\n   #chairman-message.upload-section {\r\n     background: #eef6fb;\r\n     border-left: 6px solid #1e3a5f;\r\n     padding: 40px 30px;\r\n     border-radius: 4px;\r\n     box-shadow: 0 4px 8px rgba(0,0,0,0.05);\r\n   }\r\n   #chairman-message.upload-section h3 {\r\n     font-family: 'Oswald', sans-serif;\r\n     color: #1e3a5f;\r\n     font-size: 2.2rem;\r\n     text-align: center;\r\n     text-transform: uppercase;\r\n     margin-bottom: 15px;\r\n     position: relative;\r\n   }\r\n   #chairman-message.upload-section h3::after {\r\n     content: '';\r\n     display: block;\r\n     width: 60px;\r\n     height: 4px;\r\n     background: #f1c40f;\r\n     margin: 8px auto 0;\r\n   }\r\n   #chairman-message.upload-section p {\r\n     font-family: 'Lora', serif;\r\n     font-size: 1.05rem;\r\n     line-height: 1.75;\r\n     color: #333;\r\n     text-align: justify;\r\n     margin-top: 20px;\r\n   }\r\n   #chairman-message.upload-section p::first-letter {\r\n     float: left;\r\n     font-size: 3rem;\r\n     font-weight: bold;\r\n     line-height: 1;\r\n     margin-right: 12px;\r\n     color: #1e3a5f;\r\n   }\r\n   \r\n   /* ────────────────────────────────────────────────────────────────────\r\n      Introduction extra‐lines cards\r\n   ──────────────────────────────────────────────────────────────────── */\r\n   .intro-cards-container {\r\n     display: flex;\r\n     flex-wrap: wrap;\r\n     gap: 15px;\r\n     margin-top: 10px;\r\n   }\r\n   .intro-card {\r\n     flex: 1 1 calc(25% - 15px);\r\n     padding: 15px;\r\n     border-radius: 8px;\r\n     color: #fff;\r\n     font-family: 'Oswald', sans-serif;\r\n     font-weight: 500;\r\n     box-shadow: 0 2px 6px rgba(0,0,0,0.1);\r\n     text-align: center;\r\n   }\r\n   @media (max-width: 768px) {\r\n     .intro-card { flex: 1 1 100%; }\r\n   }\r\n   "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
